import api from './api';

const litigeDocsApi = {
  // Récupérer tous les documents d'un litige (avec URLs signées)
  getAll: (litigeId) =>
    api.get(`/litiges/${litigeId}/documents`),

  // Obtenir une URL signée PUT pour uploader directement sur S3
  presign: (litigeId, { filename, contentType }) =>
    api.post(`/litiges/${litigeId}/documents/presign`, { filename, contentType }),

  // Confirmer l'upload et enregistrer les métadonnées en DB
  confirm: (litigeId, { key, filename, contentType, size, commentaire_id }) =>
    api.post(`/litiges/${litigeId}/documents/confirm`, { key, filename, contentType, size, commentaire_id }),

  // Upload direct (multipart) avec compression backend — pour PDFs
  uploadFile: (litigeId, formData) =>
    api.post(`/litiges/${litigeId}/documents/upload-file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  // Renommer un document
  rename: (litigeId, docId, nom) =>
    api.patch(`/litiges/${litigeId}/documents/${docId}`, { nom }),

  // Supprimer un document (S3 + DB)
  delete: (litigeId, docId) =>
    api.delete(`/litiges/${litigeId}/documents/${docId}`),
};

export default litigeDocsApi;
